export const defaultPickedDayToNoon = (previous, picked) => {
  if (previous || !picked) return picked;
  if (picked.getHours() !== 0 || picked.getMinutes() !== 0) return picked;

  const noon = new Date(picked);
  noon.setHours(12, 0, 0, 0);
  return noon;
};
